import React from 'react';
import '../../style/components/radioButton.css'
import NeoInput from '../neoInput';

export function RadioButton({type, value, label, onChange, key, currentValue, className='', ...rest}){
    let [isSelected, setIsSelected]= React.useState(false);
    React.useEffect(() => {
        if(value !== undefined && currentValue !== undefined) {
            if(currentValue === value){
                setIsSelected(true);
            }else{
                setIsSelected(false);
            }
        }
    }, [currentValue, value]);

    const change = React.useCallback(() => {
        onChange(value);
    }, [value, onChange]);

    return(
        <label className={`${className} radio`} for={key}>
            <input key={key} onClick={change} type={type} id={key} value={value} checked={isSelected} {...rest} />
            <span className={`${className} radio-mark`}></span>
            <span className={`${className} radio-label`}>{label}</span>
        </label>
    )
}

export default function RadioGroup({ inputs, className='', currentValue, onChange=() => {} , active, ...rest}) {
    const [activeInput, setActiveInput] = React.useState(null);

    return (
        <div className={`${className} wz-neo-input-group input-group`}>
            {inputs.map(({key, className:childClassName='', ...rest}) => {
                // copy of props to modify className in order to do not adding className at each loop
                let newClassName = `${className} ${childClassName} `;
                return <NeoInput
                    isInGroup
                    key={key}
                    className={`${newClassName} ${activeInput === key && active ? 'active' : 'inactive'}`}
                    showLabel={false}
                    onChange={(value) => {
                        setActiveInput(activeInput === key && active ? null : key);
                        onChange(activeInput === key && active ? null : value);
                    }}
                    active={active}
                    currentValue={currentValue}
                    {...rest}
                />
            })}
        </div>
    );
}
